import * as React from 'react';
import { EInsideTAInfrastructureType, EOutsideTAInfrastructureType, TInfrastructureItem } from '../../../../types/map';
import { MapInfrastructureBalloonWithRoute } from '../MapInfrastructureBalloonWithRoute';
import { MapInfrastructureBalloon } from '../MapInfrastructureBalloon';
import { MapSimilarNewbuildingBalloon } from '../MapSimilarNewbuildingBalloon';
import { getDateText } from './helpers/getDateText';
import { getIconBackgroundColor } from './helpers/getIconBackgroundColor';
import { getDescription } from './helpers/getDescription';
import { getTimeWalk } from './helpers/getTimeWalk';
import { isRouteForTypeAvailable } from './helpers/isRouteForTypeAvailable';

export interface IMapBalloonProps {
  infrastructureItem: TInfrastructureItem;
  isDistanceCalculatingEnabled: boolean;
  routeButtonIdPrefix?: string;
}

export function MapBalloon(props: IMapBalloonProps) {
  const { infrastructureItem, isDistanceCalculatingEnabled, routeButtonIdPrefix = '' } = props;

  switch (infrastructureItem.type) {
    case 'cafe':
    case 'clinic':
    case 'grocery':
    case 'metro':
    case 'nursery':
    case 'school':
    case EOutsideTAInfrastructureType.busStops:
    case EOutsideTAInfrastructureType.tramStops:
    case EOutsideTAInfrastructureType.metro:
    case EOutsideTAInfrastructureType.parking:
    case EOutsideTAInfrastructureType.bikeParking:
    case EOutsideTAInfrastructureType.chargingStations:
    case EOutsideTAInfrastructureType.scooterParking:
    case EInsideTAInfrastructureType.yardWithoutCars:
    case EInsideTAInfrastructureType.parking:
    case EInsideTAInfrastructureType.dropOffPickUpArea:
    case EInsideTAInfrastructureType.bikeParking:
    case EInsideTAInfrastructureType.chargingStations:
    case EInsideTAInfrastructureType.scooterParking:
    case EInsideTAInfrastructureType.boulevards:
    case EInsideTAInfrastructureType.trafficSafetyElements:
      if (isDistanceCalculatingEnabled && isRouteForTypeAvailable(infrastructureItem.type)) {
        return (
          <MapInfrastructureBalloonWithRoute
            routeButtonId={routeButtonIdPrefix + infrastructureItem.id}
            timeWalk={getTimeWalk(infrastructureItem)}
            title={infrastructureItem.title}
            type={infrastructureItem.type}
            iconBackgroundColor={getIconBackgroundColor(infrastructureItem)}
            dateText={getDateText(infrastructureItem)}
            description={getDescription(infrastructureItem)}
          />
        );
      }

      return (
        <MapInfrastructureBalloon
          timeWalk={getTimeWalk(infrastructureItem)}
          title={infrastructureItem.title}
          type={infrastructureItem.type}
          iconBackgroundColor={getIconBackgroundColor(infrastructureItem)}
          dateText={getDateText(infrastructureItem)}
          description={getDescription(infrastructureItem)}
        />
      );

    case 'futureRoad':
      return (
        <MapInfrastructureBalloon
          title={infrastructureItem.title}
          type={infrastructureItem.type}
          iconBackgroundColor={getIconBackgroundColor(infrastructureItem)}
          dateText={getDateText(infrastructureItem)}
        />
      );
    case 'similar_newbuilding':
      return (
        <MapSimilarNewbuildingBalloon
          ballonId={infrastructureItem.id}
          title={infrastructureItem.name}
          minPrice={infrastructureItem.minPrice}
          imageUrl={infrastructureItem.imageUrl}
          roominess={infrastructureItem.roomsSquareMeter}
          url={infrastructureItem.url}
        />
      );

    default:
      return null;
  }
}
